"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/CollectionEventType
 */

/**
 * @enum {string}
 */
var _default = {
  /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */
  ADD: 'add',

  /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */
  REMOVE: 'remove'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2I7Ozs7O0VBS0FBLEdBQUcsRUFBRSxLQU5ROztFQU9iOzs7OztFQUtBQyxNQUFNLEVBQUU7QUFaSyxDIiwibmFtZXMiOlsiQUREIiwiUkVNT1ZFIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9Db2xsZWN0aW9uRXZlbnRUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19